import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api"
import type { DashboardTemplate, DashboardTemplatePayload } from "../types"

const PATHS = {
  templates: "/dashboard/templates/",
  templateRoles: "/dashboard/templates/roles/",
  template: (id: number | string) => `/dashboard/templates/${id}/`
}

export const getDashboardTemplates = () =>
  request.api.get<DashboardTemplate[], BaseApiResponse<void>>(PATHS.templates)

// Roles a widget catalog claims. The rest resolve to a near-empty set, so
// offering them would only produce templates nobody can see.
export const getTemplateRoles = () =>
  request.api.get<{ roles: number[] }, BaseApiResponse<void>>(
    PATHS.templateRoles
  )

export const createDashboardTemplate = (payload: DashboardTemplatePayload) =>
  request.api.post<BaseApiResponse<DashboardTemplate>, BaseApiResponse<void>>(
    PATHS.templates,
    payload
  )

export const updateDashboardTemplate = (
  id: number | string,
  payload: DashboardTemplatePayload
) =>
  request.api.patch<BaseApiResponse<DashboardTemplate>, BaseApiResponse<void>>(
    PATHS.template(id),
    payload
  )

export const deleteDashboardTemplate = (id: number | string) =>
  request.api.delete<BaseApiResponse<void>, BaseApiResponse<void>>(
    PATHS.template(id)
  )
